// extracted by mini-css-extract-plugin
module.exports = {"table":"ArticleSentimentStatsTable_table__2ds8H","tableHeader":"ArticleSentimentStatsTable_tableHeader__n27L4"};